import { sortBy } from 'lodash-es'

import { ACHIEVEMENT_ID_TO_DATA } from './achievements'
import {
  ACHIEVEMENT_NAMES,
  type AchievementId,
  type UserAchievements,
  type UserProgression,
} from './types'

export default function getSortedAchievements({
  progression,
  completed = null,
}: {
  progression: Partial<UserProgression>
  completed: boolean | null
}): AchievementId[] {
  const userAchievements: UserAchievements = progression?.achievements ?? {}
  const achievementIdsToSort: AchievementId[] =
    completed == null
      ? ACHIEVEMENT_NAMES.filter(
          k => ACHIEVEMENT_ID_TO_DATA[k].category !== 'one-off' || userAchievements[k] != null
        )
      : completed === true
        ? (Object.keys(userAchievements) as AchievementId[])
        : ACHIEVEMENT_NAMES.filter(
            k => userAchievements[k] == null && ACHIEVEMENT_ID_TO_DATA[k].category !== 'one-off'
          )

  const sortedAchievementIds: AchievementId[] = sortBy(achievementIdsToSort, [
    k => ACHIEVEMENT_ID_TO_DATA[k]?.category,
    k => ACHIEVEMENT_ID_TO_DATA[k]?.criteriaValue,
  ])

  return sortedAchievementIds
}
